import * as React from 'react';
import { Header2, ModalWindow, Paragraph1, Paragraph3 } from '@cian/ui-kit';

import { IAvailableJk, IPromo } from '../../types/newbuilding/promos';
import { Author } from './inner/Author';
import { BankItem } from './inner/BankItem';
import { BanksList } from './inner/BanksList';
import { JKList } from './inner/JKList';
import * as styles from './PromoDescriptionModal.css';

interface IPromoDescriptionModalProps {
  contactsButton?: React.ReactNode;
  onClose(): void;
  onJkClick(jk: IAvailableJk, index: number): void;
  onMortgageClick(): void;
  open: boolean;
  promo: IPromo;
}

export const PromoDescriptionModal = ({
  contactsButton,
  promo,
  open,
  onClose,
  onJkClick,
  onMortgageClick,
}: IPromoDescriptionModalProps) => {
  const { availableJks, authorLogoUrl, authorName, bank, banks, description, features, isFromBuilder, name } = promo;
  const authorLabel = isFromBuilder ? 'Застройщик' : 'Агент';

  return (
    <ModalWindow open={open} fixed={false} width={640} onClose={onClose} escape outside>
      <div className={styles['content']}>
        <div className={styles['title']}>
          <Header2 as="h2">{name}</Header2>
        </div>
        {!!features.length && (
          <div className={styles['labels-container']}>
            {features.map(({ name, value }, idx) => (
              <div key={idx} className={styles['label']}>
                <Paragraph3 color="gray60_100">{name}</Paragraph3>
                <Paragraph1>{value}</Paragraph1>
              </div>
            ))}
          </div>
        )}
        {description && (
          <div className={styles['description']}>
            <Paragraph1 whiteSpace="pre-line">{description}</Paragraph1>
          </div>
        )}
        {!!availableJks.length && (
          <div className={styles['available-jks']}>
            <JKList jkList={availableJks} onJkClick={onJkClick} />
          </div>
        )}
        {!!banks.length && (
          <div className={styles['banks']}>
            <BanksList banks={banks} onMortgageClick={onMortgageClick} />
          </div>
        )}
        {bank && (
          <div className={styles['banks']}>
            <BankItem bank={bank} label="Банк" onMortgageClick={onMortgageClick} />
          </div>
        )}
        {authorName && (
          <Author label={authorLabel} name={authorName} logoUrl={authorLogoUrl} contactsButton={contactsButton} />
        )}
      </div>
    </ModalWindow>
  );
};

PromoDescriptionModal.displayName = 'PromoDescriptionModal';
